'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinTeam = exports.createTeam = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _slugify = require('slugify');

var _slugify2 = _interopRequireDefault(_slugify);

var _client = require('../../../utils/client');

var client = _interopRequireWildcard(_client);

var _params = require('../../../utils/params');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  var subdomain = client.isStaging() ? 'www.staging' : 'www';

  return {
    id: team.teamGuid,
    leader: (0, _get2.default)(team, 'captain.firstName'),
    name: team.name,
    pages: team.numberOfSupporters,
    raised: (0, _get2.default)(team, 'donationSummary.totalAmount'),
    slug: team.shortName,
    url: 'https://' + subdomain + '.justgiving.com/team/' + team.shortName
  };
};

var fetchTeams = exports.fetchTeams = function fetchTeams() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _options$campaign = options.campaign,
      campaign = _options$campaign === undefined ? (0, _params.required)() : _options$campaign,
      _options$limit = options.limit,
      limit = _options$limit === undefined ? 100 : _options$limit;


  var params = {
    CampaignGuid: campaign,
    Take: limit
  };

  return client.get('campaigns/v1/teams/search', params).then(function (data) {
    return data.results;
  });
};

var fetchTeam = exports.fetchTeam = function fetchTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return client.get('/campaigns/v1/teams/' + id + '/full');
};

var createTeam = exports.createTeam = function createTeam(params) {
  var _params$authType = params.authType,
      authType = _params$authType === undefined ? 'Bearer' : _params$authType,
      _params$name = params.name,
      name = _params$name === undefined ? (0, _params.required)() : _params$name,
      _params$campaignId = params.campaignId,
      campaignId = _params$campaignId === undefined ? (0, _params.required)() : _params$campaignId,
      _params$story = params.story,
      story = _params$story === undefined ? (0, _params.required)() : _params$story,
      _params$captainSlug = params.captainSlug,
      captainSlug = _params$captainSlug === undefined ? (0, _params.required)() : _params$captainSlug,
      coverPhotoId = params.coverPhotoId,
      _params$target = params.target,
      target = _params$target === undefined ? 1000 : _params$target,
      _params$targetType = params.targetType,
      targetType = _params$targetType === undefined ? 'Fixed' : _params$targetType,
      _params$targetCurrenc = params.targetCurrency,
      targetCurrency = _params$targetCurrenc === undefined ? 'GBP' : _params$targetCurrenc,
      _params$teamType = params.teamType,
      teamType = _params$teamType === undefined ? 'Open' : _params$teamType,
      _params$token = params.token,
      token = _params$token === undefined ? (0, _params.required)() : _params$token;


  if (authType === 'Basic') {
    throw new Error('Teams does not support basic authentication');
  }

  var payload = {
    campaignGuid: campaignId,
    captainPageShortName: captainSlug,
    coverPhotoId: coverPhotoId,
    name: name,
    story: story,
    targetCurrency: targetCurrency,
    targetType: targetType,
    teamShortName: (0, _slugify2.default)(params.name),
    teamTarget: target,
    teamType: teamType
  };

  var options = {
    headers: {
      Authorization: authType + ' ' + token
    }
  };

  return client.put('/v2/teams', payload, options).then(function (res) {
    return res.errorMessage ? Promise.reject(new Error(res.errorMessage)) : res;
  }).then(function (res) {
    return fetchTeam(res.teamGuid);
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref) {
  var _ref$authType = _ref.authType,
      authType = _ref$authType === undefined ? 'Bearer' : _ref$authType,
      _ref$pageSlug = _ref.pageSlug,
      pageSlug = _ref$pageSlug === undefined ? (0, _params.required)() : _ref$pageSlug,
      _ref$teamSlug = _ref.teamSlug,
      teamSlug = _ref$teamSlug === undefined ? (0, _params.required)() : _ref$teamSlug,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token;

  if (authType === 'Basic') {
    throw new Error('Teams does not support basic authentication');
  }

  var payload = {
    pageShortName: pageSlug
  };

  var options = {
    headers: {
      Authorization: authType + ' ' + token
    }
  };

  return client.put('/v2/teams/join/' + teamSlug, payload, options).then(function (res) {
    return res.errorMessage ? Promise.reject(new Error(res.errorMessage)) : res;
  });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/teams/justgiving/index.js
// module id = 1426
// module chunks = 0